import api from '@pray/shared/utils/api';

export interface BooksStatsResponse {
  data: {
    total: number;
    published: number;
    draft: number;
  };
}

export interface BooksStats {
  total: number;
  published: number;
  draft: number;
}

type GetBooksStatsProps = {
  artistId: string;
};

export const getBooksStats = async ({ artistId }: GetBooksStatsProps): Promise<BooksStats> => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/books/stats`;
  const response = await api.executeGetRequest<BooksStatsResponse>(url);

  return response.data.data;
};
